/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 */
import React, {useEffect} from 'react';
import 'react-native-gesture-handler';
import {View} from 'react-native';
import Router from './layout/Router';
import EStyleSheet from 'react-native-extended-stylesheet';
import store from './store';
import {Provider} from 'react-redux';
import getRem from './utils/getRem';
import Toast from 'react-native-toast-message';
import useReactNativeVectorIconInWeb from './hooks/useReactNativeVectorIconInWeb';

const {width} = getRem();
const EStyleBuild = () => {
  const {rem, hRem} = getRem();
  EStyleSheet.build({
    $rem: rem,
    $hem: hRem,
    // always call EStyleSheet.build() even if you don't use global variables!
    $textColor: '#0275d8',
  });
};
EStyleBuild();

export let reloadReactTree = () => {};

function App(): JSX.Element {
  useReactNativeVectorIconInWeb();
  const [key, setKey] = React.useState(0);
  reloadReactTree = () => setKey(v => v + 1);
  const backgroundStyle = {
    flex: 1,
  };
  // SystemNavigationBar.navigationHide();
  useEffect(() => {
    // SplashScreen.hide();
    const {width: newWidth} = getRem();
    if (newWidth !== width) {
      EStyleBuild();
      reloadReactTree();
    }
  }, []);
  return (
    <>
      <Provider store={store}>
        <View style={backgroundStyle}>
          <Router key={key} />
        </View>
      </Provider>
      <Toast />
    </>
  );
}

export default App;
